export enum FilterAccess {
  Owner = 'owner',
  View = 'view',
}

export interface UserFilter {
  id: string;
  name: string;
  viewed?: boolean;
}

export interface FilterContext {
  product: string;
  item_group?: string;
  market?: string;
  namespace?: string;
}

export interface FilterPermissions {
  user: {
    id: string;
    givenName: string;
    familyName: string;
    email: string;
  };
  access: FilterAccess;
}

export interface UpdateFilterPermissions {
  user_id: string;
  access: FilterAccess;
}

export interface Filter<T = unknown> extends UserFilter {
  permissions: FilterPermissions[];
  data?: T;
}

export interface SavedFilter extends Filter {
  criteria: FilterCriteria[];
  isUnavailable?: boolean;
  isApplied?: boolean;
  isNew?: boolean;
}

export interface Market {
  itemGroupCode: string;
  itemGroup: string;
  countryCode: string;
  country: string;
}

export interface FilterTag {
  key: string;
  value: string;
}

export interface CreateFilter {
  name: string;
  context: FilterContext;
  data: Record<string, unknown>;
}

interface CreateFilterPermissions {
  user: {
    user_id: string;
    given_name: string;
    family_name: string;
    email: string;
  };
  access: FilterAccess;
}
export interface CreateFilterResponse {
  permissions: CreateFilterPermissions[];
  context: FilterContext;
  id: string;
  name: string;
  data: Record<string, unknown>;
}

export interface UpdateFilterPermissionsRequest extends UserFilter {
  permissions: UpdateFilterPermissions[];
  sharingContext?: Market;
}

export interface FilterCriteria {
  name: string;
  value: string | string[];
}

export interface FilterCriteriaGroup {
  name: string;
  filters: FilterCriteria[];
}
